import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`D3 Scales`}</h1>
    <p>{`Scales in D3 provide a way to convert from out data as numbers or string names to pixel locations to help use place objects on our svg.`}</p>
    <p>{`Typically, we'll have our size and margin setup as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const size = {
    width: 600,
    height: 400
}

const margin = {
    top: 10,
    left: 10,
    bottom: 10,
    right: 10
}
`}</code></pre>
    <p>{`And suppose we have the following data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`console.log(data)
// the data:
// [
//     { val: 1, year: 2001 },
//     { val: 3, year: 2006 },
//     { val: 5, year: 2011 },
//     { val: 1, year: 2016 },
// ]
`}</code></pre>
    <p>{`One function that will be helpful in setting out our scales is the `}<inlineCode parentName="p">{`max`}</inlineCode>{` function.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { max } from "d3-array";

max(data, d => d.val) // 5
`}</code></pre>
    <p>{`The first argument of `}<inlineCode parentName="p">{`max`}</inlineCode>{` is an array and the second is a function that is applied to each element in the array to get the specific value we want. The `}<inlineCode parentName="p">{`max`}</inlineCode>{` function then returns the greatest of the values returned in the passed in function.`}</p>
    <p>{`In the code below, we setup a y scale. Often, we'll want the y axis to start at zero and go up to include the greatest value. We can do this by specifying the domain to be `}<inlineCode parentName="p">{`[0, maxValue]`}</inlineCode>{` where we use the `}<inlineCode parentName="p">{`max`}</inlineCode>{` function to calculate that maximum value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { scaleLinear } from "d3-array";

const y = scaleLinear()
    .domain([0, max(data, d => d.val)])
    .range([size.height - margin.bottom, margin.top])
`}</code></pre>
    <p>{`ScaleLinear creates a line to transform values in the domain to values in the range.`}</p>
    <img src="../../static/images/scaleLinear.png"></img>
    <p>{`We'll want the y scale to be increasing going up, so the 0 value should correspond to the bottom of the svg, i.e. `}<inlineCode parentName="p">{`size.height - margin.bottom`}</inlineCode>{` where the max value should correspond to the top of the svg, i.e. `}<inlineCode parentName="p">{`margin.top`}</inlineCode>{`, which are passed into the range.`}</p>
    <p>{`Similarly, we'll want to create an x scale but this time not start at 0. We can use `}<inlineCode parentName="p">{`extent`}</inlineCode>{` to help us find our domain.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { extent } from "d3-array";

extent(data, d => d.year) // [2001, 2016]
`}</code></pre>
    <p>{`Extent is similar to `}<inlineCode parentName="p">{`max`}</inlineCode>{`, but returns an array of the min and max value: `}<inlineCode parentName="p">{`[min, max]`}</inlineCode>{` and is useful especially when creating an x scale.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const x = scaleLinear()
    .domain(extent(data, d => d.year))
    .range([margin.left, size.width - margin.right])
`}</code></pre>
    <p>{`If you're ever doing a calculation inside of the `}<inlineCode parentName="p">{`.domain`}</inlineCode>{` or `}<inlineCode parentName="p">{`.range`}</inlineCode>{`, and the scale isn't working properly, you can check what the values as follows, `}<inlineCode parentName="p">{`console.log(x.domain(), x.range())`}</inlineCode>{`. Calling these functions with no values returns the current domain and range.`}</p>
    <p>{`Now, `}<inlineCode parentName="p">{`x`}</inlineCode>{` and `}<inlineCode parentName="p">{`y`}</inlineCode>{` are just functions that take in values in their domain and returns the pixel location on the svg where to place our elements. For example,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`x(2001) // 10, the margin.left value
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      